import { Autocomplete, Chip, FormControl, Grid, InputLabel, MenuItem, TextField, Typography } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { TalentSpecializations, languages } from '../../Types/General';
import { JobTitle, JobType, PaymentType, WorkSite} from '../../Types/Job';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../Redux/store';
import { setDescription, setNextDisabled, setPayAmount, setPayRate, setPrimaryLanguage, setSkills, setTitle, setType, setWorkSite } from '../../Redux/slices/JobPostingCreationSlice';
import { NumericFormat } from 'react-number-format';
import { Skill } from '../../Types/Resume';

interface JobDescriptionForm {    
    description: string;
    skills: string[],
}

export const JobDescription = () => {
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const jobPostingCreationSlice = useAppSelector( state => state.JobPostingCreation);
    const {
        control,
        formState: {dirtyFields},
        getValues,
        watch,
        setValue
    } = useForm<JobDescriptionForm>({
        defaultValues: {
            description: jobPostingCreationSlice.description ?? '',
            skills: jobPostingCreationSlice.skills ?? [],
        }
    })
    /* ******************** Variables ******************** */
    const watchFields = Object.values(watch())
    /* ******************** Functions ******************** */
    const handleChange = (val: string[]) => {
        setValue('skills', val, {shouldDirty: true})
    }
    /* ******************** Effects ******************** */
    useEffect(()=> {
        return function cleanup(){
            if (dirtyFields.description) dispatch(setDescription(getValues('description')))
            if (dirtyFields.skills) dispatch(setSkills(getValues('skills')))
        }
    }, [dirtyFields])

    useEffect(()=> {
        if (watchFields.every( field => field.length > 0) && jobPostingCreationSlice.nextDisabled) {
            dispatch(setNextDisabled(false));
        } 
        if (!watchFields.every( field => field.length > 0) && !jobPostingCreationSlice.nextDisabled) {
            dispatch(setNextDisabled(true));
        } 
    }, [watchFields])
    /* ******************** JSX ******************** */
    return (
        <>
            <Grid container display={"flex"} flexDirection={"column"} gap={'20px'}>
                <Typography variant='lora-title-large' color={'primary'} fontWeight={'bold'}>Provide a job description</Typography> 
                <Grid item display={"flex"} flexDirection={"column"} gap={'12px'}>
                    <Grid item xs display={"flex"} flexDirection={"column"}>
                            <Typography variant='body-small' color={'black.200'} marginBottom={1}>Job description</Typography> 
                                <Controller
                                    name='description'
                                    control={control}
                                    render={({field}) =>(
                                        <TextField
                                            multiline
                                            placeholder='Short job description'
                                            {...field}
                                        />
                                    )}
                                />
                    </Grid>
                    <Grid item xs display={"flex"} flexDirection={"column"}>
                        <Typography variant='body-small' color={'black.200'} marginBottom={1}>Skills required</Typography> 
                            <Controller
                                name='skills'
                                control={control}
                                render={({field}) =>(
                                    <Autocomplete
                                        multiple
                                        freeSolo
                                        autoSelect
                                        options={TalentSpecializations.map( s => s.filters).flat().sort()}
                                        defaultValue={getValues('skills')}
                                        onChange={(params, val) => {handleChange(val)}}
                                        renderTags={(value, props) =>{
                                          return value.map((option, index) => (
                                            //@ts-ignore
                                            <Chip  variant='outlined' label={option} {...props({ index })} />
                                          ))
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              placeholder={field.value.length == 0?"Type in a skill and press enter to save it": "CSS, Excel, etc."}
                                            />
                                          )}
                                    />
                                )}
                            />
                    </Grid>
                </Grid>                 
            </Grid>
        </>
    )
}